The parent location.
